import { getCounterPartiesList } from '@/fsd/entities/counter-party';
import { useInitialFilters } from '@/fsd/shared/hooks/useInitialFilters';
import {
  FilterFieldOptions,
  FilterState,
} from '@/fsd/shared/ui/filter-panel/types';
import { useEffect, useState } from 'react';
import { sanitizeMutualSettlementsFilters } from '../../lib/sanitizeMutualSettlementsFilters';
import { getMutualSettlementsFiltersFields } from '../../lib/getMutualSettlementsFiltersFields';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { getOrganisations } from '@/fsd/entities/organization';

interface IProps {
  setPage: (page: number) => void;
}

export const useGetMutualSettlementsFilters = ({ setPage }: IProps) => {
  const initialFilters = useInitialFilters({});

  const [filters, setFilters] = useState<any>(initialFilters);
  const [activeFilters, setActiveFilters] =
    useState<FilterState>(initialFilters);
  const [organizationOptions, setOrganizationOptions] = useState<
    FilterFieldOptions[]
  >([]);
  const [counterpartyOptions, setCounterpartyOptions] = useState<
    FilterFieldOptions[]
  >([]);

  const handleFilterChange = (newFilters: any) => {
    setActiveFilters(newFilters);
  };

  useEffect(() => {
    queryClient
      .fetchQuery({
        queryKey: ['organisations'],
        queryFn: getOrganisations,
      })
      .then((res) => {
        const orgs = res;
        if (Array.isArray(orgs)) {
          setOrganizationOptions(
            orgs.map((org) => ({ label: org.name, value: org.id }))
          );
        }
      });

    // Load Counterparties
    getCounterPartiesList({
      paginator: { page_current: 1, page_size: 1000 },
      sorted: [],
      filters: [],
    }).then((res) => {
      const counterparties = res?.data || [];
      setCounterpartyOptions(
        counterparties.map((c: any) => ({ label: c.name, value: c.id }))
      );
    });
  }, []);

  const handleFilterApply = (newActiveFilters: FilterState | undefined) => {
    const { requestFilters, cleanedFilters } = sanitizeMutualSettlementsFilters(
      newActiveFilters ?? activeFilters
    );

    setFilters(requestFilters);
    setActiveFilters(cleanedFilters);
    setPage(1);
  };

  const filterFields = getMutualSettlementsFiltersFields({
    counterpartyOptions,
    organizationOptions,
    filters: activeFilters,
  });

  return {
    filters,
    filterFields,
    handleFilterChange,
    handleFilterApply,
    activeFilters,
    setActiveFilters,
  };
};
